// extracted by mini-css-extract-plugin
export default {"button":"style_button__EDbEL","icon":"style_icon__Y3we9"};